import type { CrmMessages } from "./englishCrmMessages";

export const frenchCrmMessages = {
  resources: {
    companies: {
      name: "Entreprise |||| Entreprises",
      forcedCaseName: "Entreprise",
      fields: {
        name: "Nom de l'entreprise",
        website: "Site web",
        linkedin_url: "LinkedIn",
        phone_number: "Numéro de téléphone",
        created_at: "Date de création",
        nb_contacts: "Nombre de contacts",
        revenue: "Chiffre d'affaires",
        sector: "Secteur",
        size: "Taille",
        tax_identifier: "Identifiant fiscal",
        address: "Adresse",
        city: "Ville",
        zipcode: "Code postal",
        state_abbr: "État",
        country: "Pays",
        description: "Description",
        context_links: "URLs de contexte",
        sales_id: "Responsable de compte",
      },
      empty: {
        description: "Il semble que la liste de vos entreprises soit vide.",
        title: "Aucune entreprise trouvée",
      },
      field_categories: {
        contact: "Contact",
        additional_info: "Informations supplémentaires",
        address: "Adresse",
        context: "Contexte",
      },
      action: {
        create: "Créer une entreprise",
        edit: "Modifier l'entreprise",
        new: "Nouvelle entreprise",
        show: "Afficher l'entreprise",
      },
      added_on: "Ajoutée le %{date}",
      followed_by: "Suivie par %{name}",
      followed_by_you: "Suivie par vous",
      no_contacts: "Aucun contact",
      nb_contacts: "%{smart_count} contact |||| %{smart_count} contacts",
      nb_deals: "%{smart_count} affaire |||| %{smart_count} affaires",
      sizes: {
        one_employee: "1 employé",
        two_to_nine_employees: "2-9 employés",
        ten_to_forty_nine_employees: "10-49 employés",
        fifty_to_two_hundred_forty_nine_employees: "50-249 employés",
        two_hundred_fifty_or_more_employees: "250 employés ou plus",
      },
      autocomplete: {
        create_error:
          "Une erreur s'est produite lors de la création de l'entreprise",
        create_item: "Créer %{item}",
        create_label: "Commencez à taper pour créer une nouvelle entreprise",
      },
      filters: {
        only_mine: "Seulement les entreprises que je gère",
      },
    },
    contacts: {
      name: "Contact |||| Contacts",
      forcedCaseName: "Contact",
      field_categories: {
        background_info: "Informations complémentaires",
        identity: "Identité",
        misc: "Divers",
        personal_info: "Informations personnelles",
        position: "Poste",
      },
      fields: {
        first_name: "Prénom",
        last_name: "Nom",
        last_seen: "Dernière activité",
        title: "Titre",
        company_id: "Entreprise",
        email_jsonb: "Adresses e-mail",
        email: "E-mail",
        phone_jsonb: "Numéros de téléphone",
        phone_number: "Numéro de téléphone",
        linkedin_url: "URL LinkedIn",
        background: "Informations de contexte",
        has_newsletter: "Abonné à la newsletter",
        sales_id: "Responsable de compte",
      },
      action: {
        add: "Ajouter un contact",
        add_first: "Ajoutez votre premier contact",
        create: "Créer un contact",
        edit: "Modifier le contact",
        export_vcard: "Exporter en vCard",
        new: "Nouveau contact",
        show: "Afficher le contact",
      },
      background: {
        last_activity_on: "Dernière activité le %{date}",
        added_on: "Ajouté le %{date}",
        followed_by: "Suivi par %{name}",
        followed_by_you: "Suivi par vous",
        status_none: "Aucun",
      },
      position_at: "%{title} chez",
      position_at_company: "%{title} chez %{company}",
      empty: {
        description: "Il semble que votre liste de contacts soit vide.",
        title: "Aucun contact trouvé",
      },
      import: {
        title: "Importer des contacts",
        button: "Importer un fichier CSV",
        complete:
          "Import des contacts terminé. %{importCount} contacts importés, %{errorCount} erreurs",
        progress:
          "%{importCount} / %{rowCount} contacts importés, avec %{errorCount} erreurs.",
        error:
          "Échec de l'importation de ce fichier. Veuillez vous assurer que vous avez fourni un fichier CSV valide.",
        imported: "Importé",
        remaining_time: "Temps restant estimé :",
        running: "L'import est en cours, merci de ne pas fermer cet onglet.",
        sample_download: "Télécharger un exemple CSV",
        sample_hint:
          "Voici un exemple de fichier CSV que vous pouvez utiliser comme modèle",
        stop: "Arrêter l'importation",
        csv_file: "Fichier CSV",
        contacts_label: "contact |||| contacts",
      },
      inputs: {
        genders: {
          male: "Monsieur",
          female: "Madame",
          nonbinary: "Indéterminé",
        },
        personal_info_types: {
          work: "Pro",
          home: "Perso",
          other: "Autre",
        },
      },
      list: {
        error_loading: "Erreur lors du chargement des contacts",
      },
      inbox: {
        title: "Boîte de réception",
        subtitle:
          "Réponses WhatsApp individuelles en attente. Les diffusions de campagne sont exclues.",
        empty: "Aucun message WhatsApp non lu. Bravo !",
      },
      bulk_tag: {
        action: "Étiqueter",
        back: "Retour aux étiquettes",
        create_description:
          "Créez une nouvelle étiquette et appliquez-la aux contacts sélectionnés.",
        description:
          "Choisissez une étiquette existante ou créez-en une pour les contacts sélectionnés.",
        empty:
          "Aucune étiquette pour le moment. Créez-en une pour étiqueter les contacts sélectionnés.",
        error: "Impossible d'ajouter l'étiquette aux contacts",
        noop: "Les contacts sélectionnés ont déjà cette étiquette",
        success:
          "Étiquette ajoutée à %{smart_count} contact |||| Étiquette ajoutée à %{smart_count} contacts",
        title: "Ajouter une étiquette aux contacts",
      },
      merge: {
        action: "Fusionner avec un autre contact",
        confirm: "Fusionner les contacts",
        current_contact: "Contact actuel (sera supprimé)",
        description: "Fusionnez ce contact avec un autre.",
        error: "Échec de la fusion des contacts",
        merging: "Fusion...",
        no_additional_data: "Aucune donnée supplémentaire à fusionner",
        select_target: "Veuillez sélectionner un contact avec lequel fusionner",
        success: "Contacts fusionnés avec succès",
        target_contact: "Contact cible (sera conservé)",
        title: "Fusionner les contacts",
        warning_description:
          "Toutes les données seront transférées au deuxième contact. Cette action ne peut pas être annulée.",
        warning_title: "Avertissement : opération destructrice",
        what_will_be_merged: "Ce qui sera fusionné :",
      },
      filters: {
        before_last_month: "Avant le mois dernier",
        before_this_month: "Avant ce mois-ci",
        before_this_week: "Avant cette semaine",
        managed_by_me: "Géré par moi",
        ownership: "Propriété",
        inbox: "Boîte de réception",
        unassigned: "Non assigné",
        desk_queues: "Files du bureau",
        sla_overdue: "SLA — premier contact requis",
        stale_48h: "Inactif (48h+)",
        needs_whatsapp_reply: "Réponse WhatsApp requise",
        needs_reply: "Réponse requise",
        search: "Rechercher nom, entreprise...",
        this_week: "Cette semaine",
        today: "Aujourd'hui",
        tags: "Étiquettes",
        tasks: "Tâches",
      },
      sla: {
        ok: "Nouveau",
        warn: "SLA 15 min",
        overdue: "SLA dépassé",
        reassign: "Réassigner",
        assign_to: "Assigner à un agent",
        assign_placeholder: "Choisir un agent…",
        assign_confirm: "Assigner",
        reassign_ok: "Lead réassigné",
        reassign_error: "Impossible de réassigner",
        agents_only: "Seuls les managers peuvent réassigner",
      },
      qualify: {
        qualifying: "Qualification…",
      },
      assist: {
        lead_score: "Score du lead",
        next_action: "Prochaine action",
        suggest_reply: "Suggérer une réponse",
        whatsapp_chat_presets: "Préréglages rapides",
        engage: "Engager",
        call: "Appeler",
        whatsapp: "WhatsApp",
        schedule_visit: "Planifier une visite",
        score_hot: "Chaud",
        score_warm: "Tiède",
        score_cold: "Froid",
      },
      hot: {
        empty_change_status:
          'Changez le statut d\'un contact en ajoutant une note à ce contact et en cliquant sur "afficher les options".',
        empty_hint: 'Les contacts avec un statut "chaud" apparaîtront ici.',
        title: "Contacts chauds",
      },
    },
    deals: {
      name: "Affaire |||| Affaires",
      fields: {
        name: "Nom",
        description: "Description",
        company_id: "Entreprise",
        contact_ids: "Contacts",
        category: "Catégorie",
        amount: "Budget",
        expected_closing_date: "Date de clôture prévue",
        stage: "Étape",
        sales_id: "Propriétaire",
      },
      action: {
        back_to_deal: "Retour à l'affaire",
        create: "Créer une affaire",
        new: "Nouvelle affaire",
        board_view: "Tableau",
        table_view: "Liste",
        view_mode: "Vue des affaires",
      },
      field_categories: {
        misc: "Divers",
      },
      archived: {
        action: "Archiver",
        error: "Erreur : affaire non archivée",
        list_title: "Affaires archivées",
        success: "Affaire archivée",
        title: "Affaire archivée",
        view: "Afficher les affaires archivées",
      },
      inputs: {
        linked_to: "Lié à",
      },
      unarchived: {
        action: "Renvoyer au tableau",
        error: "Erreur : affaire non désarchivée",
        success: "Affaire désarchivée",
      },
      updated: "Affaire mise à jour",
      empty: {
        before_create: "avant de créer une affaire.",
        description: "Il semble que votre liste d'affaires soit vide.",
        title: "Aucune affaire trouvée",
      },
      invalid_date: "Date invalide",
    },
    notes: {
      name: "Note |||| Notes",
      forcedCaseName: "Note",
      fields: {
        status: "Statut",
        date: "Date",
        attachments: "Pièces jointes",
        contact_id: "Contact",
        deal_id: "Affaire",
      },
      action: {
        add: "Ajouter une note",
        add_first: "Ajoutez votre première note",
        delete: "Supprimer la note",
        edit: "Modifier la note",
        update: "Mettre à jour la note",
        add_this: "Ajouter cette note",
      },
      sheet: {
        create: "Créer une note",
        create_for: "Créer une note pour %{name}",
        edit: "Modifier la note",
        edit_for: "Modifier la note pour %{name}",
      },
      deleted: "Note supprimée",
      empty: "Aucune note pour l'instant",
      author_added: "%{name} a ajouté une note",
      you_added: "Vous avez ajouté une note",
      me: "Moi",
      list: {
        error_loading: "Erreur lors du chargement des notes",
      },
      note_for_contact: "Note pour %{name}",
      stepper: {
        hint: "Accédez à une page de contact et ajoutez une note",
      },
      added: "Note ajoutée",
      inputs: {
        add_note: "Ajouter une note",
        options_hint: "(joindre des fichiers ou modifier les détails)",
        show_options: "Afficher les options",
      },
      actions: {
        attach_document: "Joindre un document",
      },
      validation: {
        note_or_attachment_required: "Une note ou une pièce jointe est requise",
      },
    },
    sales: {
      name: "Utilisateur |||| Utilisateurs",
      fields: {
        first_name: "Prénom",
        last_name: "Nom",
        email: "E-mail",
        administrator: "Admin",
        disabled: "Désactivé",
      },
      create: {
        error:
          "Une erreur s'est produite lors de la création de l'utilisateur.",
        success:
          "Utilisateur créé. Ils recevront prochainement un email pour définir leur mot de passe.",
        title: "Créer un nouvel utilisateur",
      },
      edit: {
        error: "Une erreur s'est produite. Veuillez réessayer.",
        record_not_found: "Enregistrement introuvable",
        success: "Utilisateur mis à jour avec succès",
        title: "Modifier %{name}",
        reset_password: "Envoyer une réinitialisation du mot de passe",
        reset_password_success:
          "E-mail de réinitialisation du mot de passe envoyé",
        reset_password_error:
          "Échec de l'envoi de l'e-mail de réinitialisation du mot de passe",
      },
      action: {
        new: "Nouvel utilisateur",
      },
    },
    tasks: {
      name: "Tâche |||| Tâches",
      forcedCaseName: "Tâche",
      fields: {
        text: "Description",
        due_date: "Date d'échéance",
        type: "Type",
        contact_id: "Contact",
        due_short: "échéance",
      },
      action: {
        add: "Ajouter une tâche",
        create: "Créer une tâche",
        edit: "Modifier la tâche",
      },
      actions: {
        postpone_next_week: "Reporté à la semaine prochaine",
        postpone_tomorrow: "Reporter à demain",
        title: "Actions de tâche",
      },
      added: "Tâche ajoutée",
      deleted: "Tâche supprimée avec succès",
      dialog: {
        create: "Créer une tâche",
        create_for: "Créer une tâche pour %{name}",
      },
      sheet: {
        edit: "Modifier la tâche",
        edit_for: "Modifier la tâche pour %{name}",
      },
      empty: "Aucune tâche pour l'instant",
      empty_list_hint: "Les tâches ajoutées à vos contacts apparaîtront ici.",
      filters: {
        later: "Plus tard",
        overdue: "En retard",
        this_week: "Cette semaine",
        today: "Aujourd'hui",
        tomorrow: "Demain",
        with_pending: "Avec des tâches en attente",
      },
      regarding_contact: "(Concernant : %{name})",
      updated: "Tâche mise à jour",
    },
    tags: {
      name: "Étiquette |||| Étiquettes",
      action: {
        add: "Ajouter une étiquette",
        create: "Créer une nouvelle étiquette",
      },
      dialog: {
        color: "Couleur",
        create_title: "Créer une nouvelle étiquette",
        edit_title: "Modifier l'étiquette",
        name_label: "Nom de l'étiquette",
        name_placeholder: "Saisir le nom de l'étiquette",
      },
    },
    channel_partners: {
      commission_ledger: {
        title: "Registre des commissions",
        summary:
          "%{count} réservation(s) · %{agreement} d'accord · %{commission} commission · %{pending} en attente",
        empty: "Aucune réservation attribuée pour l'instant.",
        unit_unknown: "Lot N/A",
        agreement_value: "Accord",
        payout_pending: "En attente",
        payout_paid: "Payé",
        mark_paid: "Marquer payé",
        marking_paid: "En cours…",
        mark_paid_success: "Commission marquée comme payée.",
        mark_paid_failed: "Impossible de marquer la commission comme payée.",
        agents_only:
          "Seuls les managers peuvent marquer les commissions comme payées.",
      },
    },
  },
  crm: {
    action: {
      reset_password: "Réinitialiser le mot de passe",
    },
    auth: {
      first_name: "Prénom",
      last_name: "Nom",
      confirm_password: "Confirmer le mot de passe",
      confirmation_required:
        "Veuillez suivre le lien que nous venons de vous envoyer par email pour confirmer votre compte.",
      recovery_email_sent:
        "Si vous êtes un utilisateur enregistré, vous devriez recevoir prochainement un e-mail de récupération de mot de passe.",
      sign_in_failed: "Échec de la connexion.",
      sign_in_google_workspace: "Connectez-vous avec Google Workplace",
      signup: {
        create_account: "Créer un compte",
        create_first_user:
          "Créez le premier compte utilisateur pour terminer la configuration.",
        creating: "Création...",
        initial_user_created: "Utilisateur initial créé avec succès",
      },
      welcome_title: "Bienvenue sur Blivix CRM",
    },
    common: {
      activity: "Activité",
      added: "ajoutée",
      details: "Détails",
      last_activity_with_date: "dernière activité %{date}",
      load_more: "Charger plus",
      misc: "Divers",
      past: "Passé",
      read_more: "En savoir plus",
      retry: "Réessayer",
      show_less: "Afficher moins",
      task_count: "%{smart_count} tâche |||| %{smart_count} tâches",
      copied: "Copié !",
      copy: "Copier",
      loading: "Chargement...",
      me: "Moi",
    },
    changelog: {
      title: "Notes de version",
    },
    activity: {
      added_company: "%{name} a ajouté l'entreprise",
      you_added_company: "Vous avez ajouté l'entreprise",
      added_contact: "%{name} a ajouté le contact",
      you_added_contact: "Vous avez ajouté le contact",
      added_note: "%{name} a ajouté une note sur",
      you_added_note: "Vous avez ajouté une note sur",
      added_note_about_deal: "%{name} a ajouté une note sur l'affaire",
      you_added_note_about_deal: "Vous avez ajouté une note sur l'affaire",
      added_deal: "%{name} a ajouté l'affaire",
      you_added_deal: "Vous avez ajouté l'affaire",
      at_company: "chez",
      to: "à",
      load_more: "Charger plus d'activité",
    },
    dashboard: {
      deals_chart: "Revenus des affaires à venir",
      deals_pipeline: "Pipeline des affaires",
      latest_activity: "Dernière activité",
      latest_activity_error:
        "Erreur lors du chargement de la dernière activité",
      latest_notes: "Mes dernières notes",
      latest_notes_added_ago: "ajouté %{timeAgo}",
      needs_attention: {
        title: "Nécessite votre attention",
        todays_visits: "Visites du jour",
        no_shows_this_week: "Absences cette semaine",
        all_clear: "Tout est à jour — bravo !",
      },
      stepper: {
        install: "Installer Blivix CRM",
        progress: "%{step}/3 terminé",
        whats_next: "Et ensuite ?",
      },
      upcoming_tasks: "Tâches à venir",
    },
    header: {
      import_data: "Importer des données",
    },
    image_editor: {
      change: "Changer",
      drop_hint:
        "Déposez un fichier à télécharger ou cliquez pour le sélectionner.",
      editable_content: "Contenu modifiable",
      title: "Télécharger et redimensionner l'image",
      update_image: "Mettre à jour l'image",
    },
    import: {
      action: {
        download_error_report: "Téléchargez le rapport d'erreur",
        import: "Importer",
        import_another: "Importer un autre fichier",
      },
      error: {
        unable: "Impossible d'importer ce fichier.",
      },
      idle: {
        description_1:
          "Vous pouvez importer des ventes, des entreprises, des contacts, des entreprises, des notes et des tâches.",
        description_2:
          "Les données doivent se trouver dans un fichier JSON correspondant à l'exemple suivant :",
      },
      status: {
        all_success: "Tous les enregistrements ont été importés avec succès.",
        complete: "Importation terminée.",
        failed: "Échoué",
        imported: "Importé",
        in_progress: "Import en cours, veuillez ne pas quitter cette page.",
        some_failed: "Certains enregistrements n'ont pas été importés.",
        table_caption: "Statut d'importation",
      },
      title: "Importer des données",
    },
    settings: {
      about: "À propos",
      companies: {
        sectors: "Secteurs",
      },
      dark_mode_logo: "Logo du mode sombre",
      deals: {
        categories: "Catégories",
        currency: "Devise",
        pipeline_help:
          "Sélectionnez les étapes d'affaire à considérer comme des affaires dans le pipeline.",
        pipeline_statuses: "Statuts des pipelines",
        stages: "Étapes",
      },
      light_mode_logo: "Logo du mode clair",
      notes: {
        statuses: "Statuts",
      },
      reset_defaults: "Réinitialiser aux valeurs par défaut",
      save_error: "Échec de l'enregistrement de la configuration",
      saved: "Configuration enregistrée avec succès",
      saving: "Enregistrement...",
      tasks: {
        types: "Types",
      },
      preferences: "Préférences",
      title: "Paramètres",
      app_title: "Titre de l'application",
      sections: {
        branding: "Image de marque",
        agent_commission: "Commission agent",
        late_interest: "Intérêts de retard",
        hold_exclusivity: "Exclusivité des réservations",
        portal_spend: "Dépenses portails",
        whatsapp_templates: "Modèles WhatsApp",
        whatsapp_chat_presets: "Préréglages chat WhatsApp",
      },
      late_interest: {
        help: "Intérêts simples annuels appliqués aux soldes d'échéances en retard sur les lettres de demande (principal × taux × jours / 365).",
        rate_label: "Taux d'intérêt de retard annuel (%)",
      },
      hold_exclusivity: {
        help: "Activé (recommandé) : seul l'agent qui a mis l'unité en attente et les managers/admins peuvent libérer ou modifier cette réserve. Désactivé : tout agent peut modifier les réserves.",
        toggle_label:
          "Limiter les changements de réserve à l'agent détenteur + managers",
      },
      agent_commission: {
        help: "Définissez comment les agents internes perçoivent une commission sur la valeur d'accord.",
        mode_percent: "Pourcentage fixe",
        mode_slab: "Paliers",
        rate_label: "Taux de commission (%)",
        slab_min_agreement: "Seuil min. d'accord (₹)",
        slab_rate: "Taux (%)",
        add_slab: "Ajouter un palier",
        preview_title: "Aperçu en direct",
        preview_sample: "Valeur d'accord exemple : %{amount}",
        preview_result: "L'agent gagne %{rate} % → %{payout}",
      },
      portal_spend: {
        help: "Utilisé pour le CPL dans Analytique. Laissez vide si inconnu.",
      },
      whatsapp_chat_presets: {
        help: "Boutons de réponse rapide dans le chat WhatsApp du contact. Managers uniquement. Utilisez {name} pour le nom du contact. Jusqu'à %{max} préréglages.",
        title_label: "Libellé du bouton",
        body_label: "Corps du message",
        add: "Ajouter un préréglage",
        empty:
          "Aucun préréglage chat. Ajoutez-en un pour que les agents l'utilisent dans WhatsApp.",
        title_placeholder: "ex. Invitation visite de site",
        body_placeholder:
          "Namaste {name} ! Nous serions ravis de vous accueillir pour une visite…",
      },
      validation: {
        duplicate: "%{display_name} en double : %{items}",
        in_use:
          "Impossible de supprimer %{display_name} encore utilisés par des affaires : %{items}",
        validating: "Validation\u2026",
        entities: {
          categories: "catégories",
          stages: "étapes",
        },
      },
    },
    theme: {
      dark: "Sombre",
      label: "Thème",
      light: "Clair",
      system: "Système",
    },
    language: "Langue",
    navigation: {
      label: "Navigation CRM",
    },
    profile: {
      inbound: {
        description:
          "Vous pouvez commencer à envoyer des e-mails vers l'adresse de réception de votre serveur, par exemple en l'ajoutant au champ %{field}. Blivix CRM traitera les e-mails et ajoutera des notes aux contacts correspondants.",
        title: "E-mail entrant",
      },
      mcp: {
        title: "Serveur MCP",
        description:
          "Utilisez cette URL pour connecter votre assistant IA aux données de votre CRM via le Model Context Protocol (MCP).",
      },
      password: {
        change: "Changer le mot de passe",
      },
      password_reset_sent:
        "Un e-mail de réinitialisation du mot de passe a été envoyé à votre adresse e-mail",
      record_not_found: "Enregistrement introuvable",
      title: "Profil",
      updated: "Votre profil a été mis à jour",
      update_error: "Une erreur s'est produite. Veuillez réessayer",
    },
    validation: {
      invalid_url: "Doit être une URL valide",
      invalid_linkedin_url: "L'URL doit provenir de linkedin.com",
    },
    analytics: {
      title: "Analytique immobilière et performance",
      subtitle:
        "Suivez le ROI des portails, le coût par lead (CPL), le scorecard agent et le vieillissement des stocks.",
      no_leads_hint:
        "Aucun lead pour l'instant — les métriques restent à zéro tant qu'il n'y a pas de contacts.",
      no_data: "Aucune donnée",
      metrics: {
        total_leads: "Total des leads ingérés",
        total_leads_empty: "Vide tant qu'aucun contact n'est créé ou ingéré",
        total_leads_source: "Depuis la table contacts",
        site_visits: "Visites sur site effectuées",
        site_visits_count: "%{count} visite(s) enregistrée(s)",
        tokens_bookings: "Tokens / Réservations",
        tokens_bookings_source: "Depuis la table réservations",
        gross_booking_value: "Valeur brute des réservations",
        gross_booking_value_source: "Somme des valeurs d'accord",
      },
      funnel: {
        title: "Entonnoir par source",
        description:
          "Progression Lead → Contacté → Visite → Token → Réservé par portail ou source",
        empty: "Aucune donnée de source de leads.",
        conversion: "Conversion globale : %{rate}",
        steps: {
          lead: "Lead",
          contacted: "Contacté",
          visit: "Visite",
          token: "Token",
          booked: "Réservé",
        },
      },
      portal_volume: {
        title: "Volume de leads portail vs conversions visite",
        description:
          "Analyse comparative des leads bruts générés vs visites sur site effectuées par portail",
      },
      portal_roi: {
        title: "ROI source de leads et performance portail",
        description:
          "Répartition des leads, taux de contact, visites, tokens, réservations et CPL par portail",
        columns: {
          source: "Portail / Source",
          leads: "Leads",
          contacted: "Contactés",
          visits: "Visites",
          tokens: "Tokens",
          booked: "Réservés",
          cpl: "CPL",
          conversion: "Conversion",
        },
      },
      agent_scorecard: {
        title: "Scorecard agent",
        description:
          "Rapidité du premier contact, taux de présence aux visites, réservations et valeur brute",
        empty: "Aucune donnée de scorecard agent.",
        columns: {
          agent: "Agent",
          first_touch: "Premier contact moy. (min)",
          show_rate: "Taux de présence",
          completed_visits: "Visites effectuées",
          bookings: "Réservations",
          gross_value: "Valeur brute des réservations",
        },
      },
      call_leaderboard: {
        title: "Classement équipe commerciale (appels)",
        description:
          "Classement des agents selon les appels, visites sur site et valeur brute des réservations",
        columns: {
          agent: "Nom de l'agent",
          calls: "Total appels",
          site_visits: "Visites sur site",
          tokens: "Tokens",
          gross_value: "Valeur brute des réservations",
        },
      },
      inventory_aging: {
        title: "Vieillissement des stocks",
        description:
          "Unités disponibles et en attente classées par jours dans le statut actuel",
        available_footnote:
          "Les jours « Disponible » utilisent la date de création de l'unité (pas encore d'historique de changement de statut).",
        empty: "Aucun stock à afficher.",
        showing: "Affichage de %{shown} sur %{total} unités",
        status: {
          available: "Disponible",
          on_hold: "En attente",
        },
        columns: {
          unit: "Unité",
          project: "Projet",
          status: "Statut",
          days: "Jours",
        },
      },
      inventory_health: {
        title: "Santé des stocks par projet",
        description:
          "Disponibilité, tokens reçus et répartition réservé/vendu par projet promoteur",
      },
    },
  },
} satisfies CrmMessages;
